module.exports = __webpack_public_path__ + "img/3.0dfb053.jpg";